import React from 'react';
import { DialogOverlay, DialogContent } from '@reach/dialog';
//import Img from 'gatsby-image';
import {graphql, StaticQuery} from "gatsby";
import '@reach/dialog/styles.css';

class ALSDownload extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
    } 
    // componentDidMount() {

    //     this.storeInUrl = this.storeInUrl.bind(this);
    // }

    // storeInUrl = (checkCompany, checkUser) => {
    //     this.storeInUrl = this.storeInUrl.bind(this);
    // }
    render () {
                
        return(
            <StaticQuery
                query = {graphql`
                    query {
                        cross: file(relativePath: { eq: "ui-cross.png" }) {
                            childImageSharp {
                                fluid(maxWidth: 74, quality: 50) {
                                    ...GatsbyImageSharpFluid_withWebp
                                }
                            }
                        }
                        Als01OModeration: file(relativePath: { eq: "aLS/als01/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als02OModeration: file(relativePath: { eq: "aLS/als02/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als03OModeration: file(relativePath: { eq: "aLS/als03/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als04OModeration: file(relativePath: { eq: "aLS/als04/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als05OModeration: file(relativePath: { eq: "aLS/als05/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als06OModeration: file(relativePath: { eq: "aLS/als06/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als07OModeration: file(relativePath: { eq: "aLS/als07/moderation.pdf" }) {
                            name
                            publicURL
                        }
                        Als01OHandout: file(relativePath: { eq: "aLS/als01/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als02OHandout: file(relativePath: { eq: "aLS/als02/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als03OHandout: file(relativePath: { eq: "aLS/als03/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als04OHandout: file(relativePath: { eq: "aLS/als04/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als05OHandout: file(relativePath: { eq: "aLS/als05/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als06OHandout: file(relativePath: { eq: "aLS/als06/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als07OHandout: file(relativePath: { eq: "aLS/als07/handout.pdf" }) {
                            name
                            publicURL
                        }
                        Als01OKonstruktion: file(relativePath: { eq: "aLS/als01/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als02OKonstruktion: file(relativePath: { eq: "aLS/als02/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als03OKonstruktion: file(relativePath: { eq: "aLS/als03/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als04OKonstruktion: file(relativePath: { eq: "aLS/als04/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als05OKonstruktion: file(relativePath: { eq: "aLS/als05/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als06OKonstruktion: file(relativePath: { eq: "aLS/als06/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als07OKonstruktion: file(relativePath: { eq: "aLS/als07/konstruktion.pdf" }) {
                            name
                            publicURL
                        }
                        Als01ODruckvorlagen: file(relativePath: { eq: "aLS/als01/druckvorlagen.zip" }) {
                            name
                            publicURL
                        }
                        Als02ODruckvorlagen: file(relativePath: { eq: "aLS/als02/druckvorlagen.zip" }) {
                            name
                            publicURL
                        }
                        Als03ODruckvorlagen: file(relativePath: { eq: "aLS/als03/druckvorlagen.zip" }) {
                            name
                            publicURL
                        }
                        Als04ODruckvorlagen: file(relativePath: { eq: "aLS/als04/druckvorlagen.zip" }) {
                            name
                            publicURL
                        }
                        Als05ODruckvorlagen: file(relativePath: { eq: "aLS/als05/druckvorlagen.pdf" }) {
                            name
                            publicURL
                        }
                        Als06ODruckvorlagen: file(relativePath: { eq: "aLS/als06/druckvorlagen.zip" }) {
                            name
                            publicURL
                        }
                        Als07ODruckvorlagen: file(relativePath: { eq: "aLS/als07/druckvorlagen.zip" }) {
                            name
                            publicURL
                        }
                    }
                `}
                render = { data => ( 
                    // const moderation = {this.props.moderation} 
                    <div>
                        {<DialogOverlay className="login-dialog-overlay" >
                            <DialogContent          
                                className="login-dialog-content"
                                aria-label= "login"    
                            >
                            <div className="login-box">
                                <div>
                                    <h1>Materialien für<br /> {this.props.motto}</h1>
                                    <p>Am 23.06.2023 werden beim Awareness Forum 
                                    des Forschungsprojektes alle Materialien vorgestellt 
                                    und können von KMU für interne, nicht-kommerzielle 
                                    Schulungszwecke heruntergeladen werden: 
                                    <br/><br/>
                                        1.  <a  href={data[this.props.moderation].publicURL}
                                                target="_blank" 
                                                rel="noreferrer">
                                            Moderationsanleitung</a>
                                        <br/>
                                        2.  <a  href={data[this.props.konstruktion].publicURL}
                                                target="_blank" 
                                                rel="noreferrer">
                                            Konstruktionsanleitung</a>
                                        <br/>
                                        3.  <a  href={data[this.props.handout].publicURL}
                                                target="_blank" 
                                                rel="noreferrer">
                                            Handout</a>
                                        <br/>
                                        4.  <a  href={data[this.props.vorlage].publicURL}
                                                target="_blank" 
                                                rel="noreferrer">
                                            Druckvorlage(n)</a>
                                            <br/>

                                        <br/><br/>
                                        Ihr Forschungs-Team.
                                    </p>
                                </div>
                            </div>
                            </DialogContent>
                        </DialogOverlay>  
                        } 
                    </div>
                )}
            />
        )
    };
}

export default ALSDownload